module.exports = __webpack_public_path__ + "media/images/application/template/arrow-up-bb259190e43ab72b1d84622373ac1a06.png";